export type { MenuDividerProps, MenuDividerSlots, MenuDividerState } from './components/MenuDivider/index';
export {
  MenuDivider,
  menuDividerClassNames,
  renderMenuDivider_unstable,
  useMenuDividerStyles_unstable,
  useMenuDivider_unstable,
} from './components/MenuDivider/index';
